import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { constants } from "app/constants";
import { LoginService } from "app/services/login.service";
import { SpinnerService } from "app/services/spinner.service";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { tap, switchMap, catchError } from "rxjs/operators";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    
    constructor(
        private loginService: LoginService,
        private spinnerServcie: SpinnerService,
        private http: HttpClient
    ) { }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Start spinner on request start
        this.spinnerServcie.requestStarted();

        let user_id = sessionStorage.getItem('user_id') || '';
        console.log('ENTERED');
        console.log(request.url);
        
        if (!(request.url.includes('token/refresh') || user_id === undefined || user_id === null || user_id === '')) {
            
            const accessTime = sessionStorage.getItem('access_time');
            const refreshTime = sessionStorage.getItem('refresh_time');

            if (!accessTime || !refreshTime) {
                console.log('NO TIMEEEEE');
    
                this.spinnerServcie.resetSpinner();
                this.loginService.logoutUserUpdates();
                alert('Something is wrong with Access or Refresh Time.')
                throw Error;
            }

            console.log('USER ID PRESENTTTTTT');

            const accessExpiry = new Date(accessTime);
            accessExpiry.setMinutes(accessExpiry.getMinutes() + constants.ACCESS_DELTA_TIME);
    
            const refreshExpiry = new Date(refreshTime);
            refreshExpiry.setMinutes(refreshExpiry.getMinutes() + constants.REFRESH_DELTA_TIME);

            // If 'GET' request pass 'user_id'
            if (request.method.toLowerCase() === 'get') {
                request = request.clone({
                    params: request.params.set('user_id', user_id.toString())
                });
            }

            const currentDate = new Date();
            if (currentDate > refreshExpiry) {
                console.log('LOGOUTT');
                this.spinnerServcie.requestEnded();
                this.loginService.logoutUserUpdates();
                throw Error;
            } else {
                currentDate.setMinutes(currentDate.getMinutes() + 1);
                console.log('1ST ALERT CHECK');

                if (this.loginService.refreshAlertRemaining && currentDate > refreshExpiry) {
                    console.log('1 MIN ALERTT');

                    this.loginService.refreshAlertRemaining = 0;
                    alert('You will be logged out soon. Please logout and re-login when work is done');
                } else {
                    console.log('2ND ALERT CHECK');

                    currentDate.setMinutes(currentDate.getMinutes() + 3);
                    if (this.loginService.refreshAlertRemaining == 2 && currentDate > refreshExpiry) {
                        console.log('3 MIN ALERTT');

                        this.loginService.refreshAlertRemaining = 1;
                        alert('You will be logged out in sometime. Please logout and re-login when work is done');
                    }
                }
            }

            console.log('REFRESH EXPIRY CHECK COMPLETEDDDDDD');

            if (new Date() > accessExpiry) {
                console.log('ACCESSS EXPIRYYYYYY');
                // sessionStorage.removeItem('access_time');

                return this.http.post(environment.host_api + "api/token/refresh/", {refresh: sessionStorage.getItem("refresh")}, {withCredentials: true}).pipe(
                    switchMap((res: any) => {
                        console.log('NEW ACCESSSSSS');

                        const dt = new Date();
                        sessionStorage.setItem('access', res.access);
                        sessionStorage.setItem('access_time', dt.toString());
    
                        request = request.clone({
                            setHeaders: {
                                Authorization: 'Bearer ' + res.access
                            }
                        });
                        return next.handle(request).pipe(tap((event) => {
                            console.log('REQUEST AFTER NEW ACCESSS');

                            if (event instanceof HttpResponse) {
                                // Stop spinner on request end
                                this.spinnerServcie.requestEnded();
                            }
                        },
                        (error: HttpErrorResponse) => {
                            console.log('ERRORRRR 000');

                            this.spinnerServcie.resetSpinner();
                            throw error;
                        }));
                    }),
                    catchError((e) => {
                        if (this.loginService.isUserLoggedIn) {
                            alert('Failed to get access token, try re-login or else contact administrator');
                        }
                        console.log('EXECUTED ERROR');
                        this.spinnerServcie.resetSpinner();
                        this.loginService.logoutUserUpdates();
                        throw Error;
                    }))
            } else {
                request = request.clone({
                    setHeaders: {
                        Authorization: 'Bearer ' + sessionStorage.getItem('access')
                    }
                });
                
                return next.handle(request).pipe(tap((event) => {
                    console.log('REQUEST WITH ACCESSSSSSS');

                    if (event instanceof HttpResponse) {
                        this.spinnerServcie.requestEnded();
                    }
                },
                (error: HttpErrorResponse) => {
                    console.log('ERR 111111');

                    this.spinnerServcie.resetSpinner();
                    throw error;
                }));
            }
        } else {
            console.log('NO USER');

            return next.handle(request).pipe(tap((event) => {
                console.log('REQUEST WITHOUT USERRRRRRR');

                if (event instanceof HttpResponse) {
                    console.log('RES RECEIVED');
                    this.spinnerServcie.requestEnded();
                }
            },
            (error: HttpErrorResponse) => {
                console.log('ERR 2');

                this.spinnerServcie.resetSpinner();
                throw error;
            }));
        }
    }
}
